import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';

// checks sessionStorage for uuid, used for authentication
export function isAuthenticated() {
  return (sessionStorage.getItem('uuid') !== null);
}

// custom class wrapping react router Route to add authentication checks for Route access
export class ProtectedRoute extends Component {
  constructor(props) {
    super();
  }

  // renders component passed to Route if user is authenticated,
  // otherwise uses Redirect component to direct user to login page
  // this.props.exact decides if url has to be exact, needed to decide
  // behaviour on different url paths
  // this.props.path contains path trigger for Route
  // this.props.component contains component to be rendered
  // this.props.render used in place of this.props.component to share
  // data if component needs additional props for rendering
  render() {
    const {
      exact, path, component, render,
    } = this.props;
    return isAuthenticated() ? (
      <Route
        exact={exact}
        path={path}
        component={component}
        render={render}
      />
    ) : (
      <Redirect to="/login" />
    );
  }
}
